import { Box } from '@mui/material';
import { TextUIPart } from 'ai';
import { ReactNode } from 'react';
import { Streamdown } from 'streamdown';

import { allowedTags, components } from '../MessageRenderer/MessageRenderer.config';

export type ChatMessageTextPartProps = {
  part: TextUIPart;

  isStreaming?: boolean;
};

export const ChatMessageTextPart = (props: ChatMessageTextPartProps): ReactNode => {
  const { part, isStreaming } = props;

  return (
    <Box sx={{ maxWidth: 'md', overflow: 'hidden' }}>
      <Streamdown isAnimating={isStreaming} mode="streaming" components={components} allowedTags={allowedTags}>
        {part.text}
      </Streamdown>
    </Box>
  );
};
